import Fetcher from '../../../services/Fetcher'
import {
  API_DICTIONARY,
  HTTP_METHODS,
  ResponseWithPagination,
  TOptionsResponse,
  VALIDATION_MESSAGES
} from '../../../constants'
import { TOption } from '../../../components/Select/types'
import { TAdditionalValue } from '../types'
import { IPartialUserInfo } from '../../../redux/store/user/types'

const fetcher = new Fetcher({})

export const addAdditionalValues = async (data) =>
  fetcher.request<unknown, TAdditionalValue>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.ADDITIONAL_VALUES}`,
    method: HTTP_METHODS.POST,
    successMessage: `Additional value ${VALIDATION_MESSAGES.SM0009} added.`,
    data
  })

export const editAdditionalValues = async (uuid: string, data) =>
  fetcher.request<unknown, TAdditionalValue>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.ADDITIONAL_VALUES}${uuid}/`,
    method: HTTP_METHODS.PATCH,
    successMessage: `Additional value ${VALIDATION_MESSAGES.SM0009} updated.`,
    data
  })

export const getAdditionalValue = async (uuid) =>
  fetcher.request<unknown, TAdditionalValue>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.ADDITIONAL_VALUES}${uuid}`,
    method: HTTP_METHODS.GET
  })

export const getTypeOptionsRequest = async () =>
  fetcher.request<unknown, ResponseWithPagination<TOptionsResponse>>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.ADDITIONAL_VALUES}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.TYPE}`,
    method: HTTP_METHODS.GET
  })

export const getSubtypeOptionsRequest = async (params) =>
  fetcher.request<unknown, ResponseWithPagination<TOption>>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.ADDITIONAL_VALUES}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.SUBTYPE}`,
    method: HTTP_METHODS.GET,
    params
  })

export const getHSOptionsRequest = async () =>
  fetcher.request<unknown, ResponseWithPagination<TOption>>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.ADDITIONAL_VALUES}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.HEALTH_SYSTEM}`,
    method: HTTP_METHODS.GET
  })

export const getHospitalOptionsRequest = async (params) =>
  fetcher.request<unknown, ResponseWithPagination<TOption>>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.ADDITIONAL_VALUES}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.HOSPITAL}`,
    method: HTTP_METHODS.GET,
    params
  })

export const getSourcingPersonOptionsRequest = async (params) =>
  fetcher.request<unknown, ResponseWithPagination<IPartialUserInfo>>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.ADDITIONAL_VALUES}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.SOURCING_PERSON}`,
    method: HTTP_METHODS.GET,
    params
  })

export const getCCOptionsRequest = async (params) =>
  fetcher.request<unknown, ResponseWithPagination<TOption>>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.ADDITIONAL_VALUES}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.CONTRACT_CATEGORY}`,
    method: HTTP_METHODS.GET,
    params
  })
